export const dateTypeFormat           : string  = 'dd:mm:yyyy'
export const rcDateTypeFormat         : string  = 'dd-mm-yyyy'
export const timeTypeFormat           : string  = 'HH:MM'
export const rcTimeTypeFormat         : string  = 'HH:MM:ss'
export const AIRPORT_CAPS             : string  = "AIRPORT"
export const AIRPORT                  : string  = "airport"
export const ONE_WAY                  : string  = "ONE_WAY"
export const OUTSTATION_ONE_WAY       : string  = "one-way"
export const SELF_DRIVE               : string  = "SELF_DRIVE"
export const OUTSTATION_ROUND_TRIP    : string  = "round-trip"
export const SELFDRIVE                : string  = "sd"
export const OUTSTATTION_MULTICITY    :string   = "mc"
export const LOCAL_RENTAL             : string  = 'LOCAL_RENTAL'
export const ROUND_TRIP               : string  = 'ROUND_TRIP'
export const Hr                       : string  = 'hr'
export const Rental                   : string  = 'rental'
export const seoRoutePageName         : string  = 'seo:domestic cabs:listing:route'
export const seoCityPageName          : string  = 'seo:domestic cabs:listing:city'
export const seoCityCarTypeName       : string  = 'seo:domestic cabs:listing:city_cartype'
export const seoAirportCityPageName   : string  = 'seo:domestic cabs:listing:airport_city'
export const seoAirportRoutePageName  : string  = 'seo:domestic cabs:listing:airport_route'
export const seoRentalPageName        : string  = 'seo:domestic cabs:listing:rental'
export const seoRouteCarTypeName      : string  = 'seo:domestic cabs:listing:route_cartype'
export const seoRouteRydePageName     : string  = 'seo:domestic cabs:listing:route_ryde'
export const RoutePageComp            : string  = 'RoutePage'
export const AirportPageComp          : string  = 'AirportPage'
export const CityPageComp             : string  = 'CityPage'
export const RentalPageComp           : string  = 'RentalPage'
export const RENTAL_CAB               : string  = 'Rental Cab'
export const ROUND_TRIP_OUTSTATION_CAB: string  = 'Outstation Cab'
export const AIRPORT_CAB              : string  = 'Airport Cab'
export const OUTSTATION_CAB           : string  = 'Cab'
export const LISTINGPAGE              : string  = 'SRP'
export const TIMEZONE                 : string  = 'GMT'
export const COUNTRYCODE              : string  = 'IN'
export const COUNTRYNAME              : string  = 'India'
export const LOBNAME                  : string  = 'cab'
export const LOBCATEGORY              : string  = 'cabs-OC'
export const SEARCH_CONTEXT_LOB       : string  = 'cabs'
export const LOCUS_DEFAULT_CITY_TYPE  : string  = 'CITY'
export const RouteCountry             : string  = 'India'

//Routes 
export const CABS_LANDING_ROUTE : string  = "/cars"   
export const CABS_LISTING_ROUTE : string  = "/cars/review"   
export const CABS_REVIEW_ROUTE  : string  = "/cars/confirm" 
export const PAYMENT_PAGE_ROUTE : string  = "/cars/checkout"

//components
export const CABS_REVIEW_PAGE       : string  = "ReviewPage"
export const CABS_HOME_PAGE         : string  = "HomePage"
export const HOME_SEARCH_WIDGET     : string  = "HomeSearchWidget"
export const MODIFY_SEARCH_HEADER   : string  = "ModifySearchHeaderUI"
export const RECENT_SEARCH_UI       : string  = "RecentSearchUI"
export const CAB_LIST_ITEM          : string  = "CabListItemUI"
export const OFFERS_COMPONENT       : string  = "OffersComponent"
export const PAYMENT_OFFERS         : string  = "PaymentOffers"
export const PAYMENT_COMPONENT      : string  = "PaymentComponentUI"
export const CAB_FEATURE_CARD       : string  = "CabFeatureCard"
export const OFFERS_BANNER          : string  = "OffersBanner"
export const AUTOSUGGEST_PAGE       : string  = "AutoSuggest"
export const FILTER_COMPONENT       : string  = "Filter"
export const SEARCH_PAGE            : string  = "SearchPage"
export const REVIEW_ITEMS           : string  = "ReviewItems"
export const LISTING_PAGE           : string  = "Listing"
export const TRAVELLER_DETAILS_UI   : string  = "TravellerDetailsUI"
export const CAB_HOURLY_CAROUSEL_UI : string  = "CabHourlyCarouselUI"

export const MOB_CABS_LANDING                     : string  = "Mob_cabs_landing"
export const MOB_CABS_LISTING                     : string  = "Mob_cabs_listing"
export const MOB_CABS_REVIEW                      : string  = "Mob_cabs_review"
export const CAB_IMAGE_TYPE                       : string  = "cab_image_type"
export const CAB_VARIANT_IMAGES                   : string  = "cab_variant_images"
export const VIEW_ALL_REVIEWS                     : string  = "view_all_reviews"
export const OFFER_CAROUSEL_INCREMENT_CLICK       : string  = "offer_carousel_increment_click"
export const OFFER_CAROUSEL_DECREMENT_CLICK       : string  = "offer_carousel_decrement_click"
export const CAB_FEATURE_CAROUSEL_INCREMENT_CLICK : string  = "cab_feature_carousel_increment_click"
export const CAB_FEATURE_CAROUSEL_DECREMENT_CLICK : string  = "cab_feature_carousel_decrement_click"
export const PICKUP_ADDRESS_FIELD                 : string  = "pickup_address_field"
export const DROP_ADDRESS_FIELD                   : string  = "drop_address_field"
export const ADDRESS_SWAP                         : string  = "address_swap"
export const SEARCH                               : string  = "search"
export const RECENT_SEARCH                        : string  = "recent_search"
export const CAB_SELECT                           : string  = "cab_select"
export const OFFER_SELECTED                       : string  = "offer_selected"
export const OFFER_REMOVED                        : string  = "offer_removed"
export const APPLY                                : string  = "apply"
export const LOGIN_NOW                            : string  = "login_now"
export const APPLY_GO_CASH                        : string  = "apply_go_cash"
export const REMOVED_GO_CASH                      : string  = "remove_go_cash"
export const VIEW_PAYMENT_INFO                    : string  = "view_payment_info"
export const FULL_PAYMENT                         : string  = "full_payment"
export const PARTIAL_PAYMENT                      : string  = "partial_payment"
export const PERSUASION_DETAILS                   : string  = "persuasion_details"
export const PICKUP_DATE_CALANDER                 : string  = "pickup_date_calander"
export const PICKUP_TIME_CALANDER                 : string  = "pickup_time_calander"
export const RETURN_DATE_CALANDER                 : string  = "return_date_calander"
export const RETURN_TIME_CALANDER                 : string  = "return_time_calander"
export const PICKUP_DATE_UPDATE                   : string  = "pickup_date_update"
export const PICKUP_TIME_UPDATE                   : string  = "pickup_time_update"
export const RETURN_DATE_UPDATE                   : string  = "return_date_update"
export const RETURN_TIME_UPDATE                   : string  = "return_time_update"
export const EXPLORE_MORE                         : string  = "explore_more"
export const AUTOSUGGEST_CURRENT_LOCATION         : string  = "autosuggest_current_location"
export const AUTOSUGGEST_PICKUP_LOCATION          : string  = "autosuggest_pickup_location"
export const AUTOSUGGEST_DROP_LOCATION            : string  = "autosuggest_drop_location"
export const PAY                                  : string  = "pay"
export const SHOW_ALL                             : string  = "show_all"
export const BACK_TO_TOP                          : string  = "back_to_top"
export const KNOW_MORE                            : string  = "know_more"
export const NO_RESULT                            : string  = "Mob_cabs_listing_no_results"
export const SRP_SUCCESS                          : string  = "Mob_cabs_listing_srp_success"
export const PICKUP_ERROR                         : string  = "pickup_error"
export const DROP_ERROR                           : string  = "drop_error"
export const PICKUP_DROP_SAME_ERROR               : string  = "pickup_drop_same_error"
export const SELECT_PACKAGE_ERROR                 : string  = "select_package_error"
export const VALID_NAME_ERROR                     : string  = "valid_name_error"
export const VALID_PH_NUM_ERROR                   : string  = "valid_phn_number_error"
export const VALID_EMAIL_ERROR                    : string  = "valid_email_error"
export const EXACT_LOCATION_ERROR                 : string  = "exact_location_error"
export const DYNAMIC_ERROR                        : string  = "dynamic_error"
export const GSTIN_SUBMIT_ERROR                   : string  = "gstin_submit_error"
export const RENTAL_PACKAGE                       : string  = "rental_package"
export const EXACT_LOCATION_NEEDED                : string  = "exact_location_needed"
export const SET_PICKUP_AS_GSTIN_SELECTED         : string  = "set_pickup_as_gstin_selected"
export const SET_PICKUP_AS_GSTIN_UNSELECTED       : string  = "set_pickup_as_gstin_unselected"
export const MOB_CAB_SEO_ASSISTED_FORM_SHOWN      : string  = "Mob_cab_seo_assisted_form_shown"
export const MOB_CAB_SEO_ASSISTED_FORM_SUBMITTED  : string  = "Mob_cab_seo_assisted_form_submitted"
export const LEAD_GEN_FORM                        : string  = "LEAD_GEN_FORM"
